import { IconButton, SliderModal, Text, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { ScrollView } from 'native-base';
import React from 'react';

import { useBatchTicketResumeDetail } from '../../../../hooks/batchTicketResumeDetail';

import { AddedItems } from './components/AddedItems';

interface BatchTicketResumeDetailProps {}

export const BatchTicketResumeDetail: React.FC<BatchTicketResumeDetailProps> = () => {
  const { getSliderModalWidth, handleGoBack, addedItemsIsEmpty, itemsAddedData, noticeProps } =
    useBatchTicketResumeDetail();

  const isMobile = useBreakpointValue({ base: true, sm: false });
  const isDesktop = useBreakpointValue({ base: false, lg: true });

  return (
    <SliderModal
      dismissWhenClickOutside
      onDismiss={handleGoBack}
      width={getSliderModalWidth(isDesktop)}>
      <ScrollView showsVerticalScrollIndicator={false}>
        <VStack pt={Spacing['inline.xxs']} space={Spacing['inline.xxxs']}>
          <HStack
            px={{ base: Spacing['inline.xxxs'], sm: Spacing['inline.xxs'] }}
            borderTopRadius={{ base: BoxRadius.md, lg: 0 }}
            alignItems="center"
            justifyContent="space-between">
            <HStack
              alignItems="center"
              space={{ base: Spacing['inline.xxxs'], sm: Spacing['inline.quarck'] }}>
              <IconButton
                testId="icon"
                icon="ArrowLeft"
                iconSize="xxs"
                p={0}
                backgroundColor="transparent"
                iconColor={Color['brand.primary.principal']}
                onPress={handleGoBack}
              />
              <Text variant="bold" fontSize={Typography['fontsize.lg']} color="neutral.black">
                Detalhes do cliente
              </Text>
            </HStack>
            {!isMobile && (
              <IconButton
                testId="icon"
                icon="CloseModal"
                iconSize="xs"
                p={0}
                variant="rounded"
                borderWidth={0.05}
                backgroundColor="transparent"
                iconColor={Color['brand.primary.principal']}
                borderColor={Color['brand.primary.principal']}
                onPress={handleGoBack}
              />
            )}
          </HStack>
        </VStack>
        <AddedItems
          noticeProps={noticeProps}
          addedItemsIsEmpty={addedItemsIsEmpty}
          itemsAddedData={itemsAddedData}
        />
      </ScrollView>
    </SliderModal>
  );
};
